import {AfterViewInit, Component, ElementRef, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../services/auth.service";
import {Admin} from "../models/admin";
import {ActivatedRoute, Router} from "@angular/router";
import {AdminLogin} from "../models/adminLogin";
import {EMAIL, EMAIL_LABEL, PASSWORD, PASSWORD_LABEL} from "../constants/text-constants";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  loginForm!: FormGroup
  admin: Admin
  isAuthenticated: boolean = true;
  passwordFieldType: string = 'password';
  isEmailBlurred = false;
  isPasswordBlurred = false;
  isGoogleLoginError: boolean = false;

  constructor(private route: ActivatedRoute,
              private authService: AuthService,
              private elementRef: ElementRef,
              private router: Router) {
    this.admin = {} as Admin;
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required, Validators.pattern('^(?=.*[A-Z])(?=.*\\d).{8,}$')]),
      rememberMe: new FormControl(false)
    });
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(queryParams => {
      const emailToken = queryParams['emailToken'];
      const code = queryParams['code'];
      if (code) {
        this.oAuthTokenRequestByCode(code);
      } else if (emailToken) {
        this.authService.confirmRegistration(emailToken).subscribe(
          {
            next: (retrievedAdmin:Admin) => {
              this.admin = retrievedAdmin;
            },
          }
        )
      }
      this.removingQueryParamAfterReceiving();
    })
  }

  private oAuthTokenRequestByCode(code: any) {
    this.authService.getOAuthTokenByCode(code).subscribe({
      next: oAuthToken => {
        this.getAdminToken(oAuthToken);
      },
      error: err => {
        if (err.status === 401) {
          this.isGoogleLoginError = true;
        }
      }
    })
  }

  private getAdminToken(oAuthToken: string) {
    this.authService.getAdminTokenByOAuthToken(oAuthToken).subscribe({
      next: adminToken => {
        this.authService.setToken(adminToken);
        this.router.navigate(["/dashboard"]);
      }
    })
  }

  private removingQueryParamAfterReceiving() {
    this.router.navigate([], {
      queryParams: {},
      replaceUrl: true,
    });
  }

  submit() {
    if (this.loginForm.invalid) {
      return;
    } else {
      const admin = this.loginForm.getRawValue() as AdminLogin
      admin.password = admin.password.trim();
      admin.email = admin.email.toLowerCase().trim();
      this.authService.login(admin).subscribe(res => {
          this.authService.setToken(res);
          this.router.navigate(["/dashboard"])
        },
        (error) => {
          this.isAuthenticated = false;
          setTimeout(() => {
            this.isAuthenticated = true
          }, 10000);
        })
    }
  }

  ngAfterViewInit(): void {
    const inputs = this.elementRef.nativeElement.querySelectorAll('input');
    inputs.forEach((input: any) => {
      input.autocomplete = 'off';
    });
  }

  get email() {
    return this.loginForm.get('email');
  }

  get password() {
    return this.loginForm.get('password');
  }

  togglePasswordVisibility(): void {
    this.passwordFieldType = (this.passwordFieldType === 'password') ? 'text' : 'password';
  }

  onFocus(field: string) {
    if (field === PASSWORD) {
      this.isPasswordBlurred = false;
    } else if (field === EMAIL) {
      this.isEmailBlurred = false;
    }
  }

  onBlur(field: string) {
    if (field === PASSWORD) {
      this.isPasswordBlurred = true;
    } else if (field === EMAIL) {
      this.isEmailBlurred = true;
    }
  }

  loginWithGoogle() {
    this.authService.loginWithGoogle().subscribe({
      next: result => {
        window.location.href = result;
      },
    });
  }

  protected readonly EMAIL_LABEL = EMAIL_LABEL;
  protected readonly PASSWORD_LABEL = PASSWORD_LABEL;
  protected readonly EMAIL = EMAIL;
  protected readonly PASSWORD = PASSWORD;
}
